import z from 'zod'

export const ListOrdersSchema = z.object({
    page: z.number(),
    perPage: z.number(),
})
